import self from "../img/self.png"
import AreaManage from "../img/AreaManage.png"
import algoplan from "../img/algoplan.png"
import OrderManagement from "../img/OrderManagement.jpeg"
import flexleasing from "../img/flexleasing.png"
import starc from "../img/starc.png"
import mounthealing from "../img/mounthealing.png"
import agenticai from "../img/agenticai.svg"
export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];

export const info = {
    firstName: "Irfan",
    lastName: "Ullah",
    initials: "Irfan", // the example uses first and last, but feel free to use three or more if you like.
    position: "Full Stack Developer | Agentic AI & Workflow Automation",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
    miniBio: [
        {
            emoji: '⚡',
            text: '8 Years of Full-Stack Experience'
        },
        {
            emoji: '🌎',
            text: 'Islamabad, Pakistan'
        },
        {
            emoji: "💼",
            text: "Full Stack Developer at Blutech Consulting"
        },
        {
            emoji: "📧",
            text: "irfan.balghari@gmail.com"
        }
    ],
    socials: [
        {
            link: "https://facebook.com/irfanbalghari",
            icon: 'fa fa-facebook'
        },
        {
            link: "https://instagram.com/irfanbalghari",
            icon: 'fa fa-instagram'
        },
        {
            link: "https://github.com/irfanbalghari",
            icon: "fa fa-github"
        },
        {
            link: "https://pk.linkedin.com/in/irfanbalghari",
            icon: "fa fa-linkedin"
        },
        {
            link: "https://twitter.com/irfanbalghari",
            icon: "fa fa-twitter"
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Full Stack Developer at Blutech Consulting building agentic AI systems and workflow automation solutions that help businesses operate smarter, not just faster. With 8 years of full-stack experience, I've evolved from building enterprise web applications to architecting intelligent, autonomous systems that combine LLMs, agent orchestration, and process automation with the reliability of traditional software engineering — designing agentic AI workflows with Python on the backend and React on the frontend to turn complex, manual processes into automated, self-directing pipelines. Before this, I spent years delivering enterprise-grade applications across .NET Core, Angular, and Azure, which taught me clean architecture, scalable backend design, and what it takes to ship software teams can depend on — rigor I now bring to the agentic AI space, where the tooling is new but the fundamentals of good engineering haven't changed.",
    skills:
        {
            proficientWith: ['Python', 'JavaScript', 'TypeScript', 'C#', 'Agentic AI', 'LLM Integration', 'Workflow Automation', 'Prompt Engineering', 'React', 'Redux', 'Angular', '.NET', 'ASP.NET Core', 'REST APIs', 'Microservices', 'PostgreSQL', 'MongoDB', 'MS SQL Server', 'Azure', 'AWS', 'Docker', 'GitLab', 'CI/CD Pipelines'],
            exposedTo: ['Material Design', 'Ant Design', 'VS Code', 'Visual Studio', 'Jira', 'Nx', 'MFE', 'Ngxs Store', 'Docker Compose', 'MySQL', 'Netlify', 'Turf.js', 'PrimeNG']
        }
    ,
    hobbies: [
        {
            label: 'reading',
            emoji: '📖'
        },
        {
            label: 'hiking',
            emoji: '🥾'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'cooking',
            emoji: '🌶'
        }
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        {
            title: "Agentic AI",
            live: "https://github.com/irfanbalghari",
            source: "https://github.com/irfanbalghari",
            image: agenticai,
            description: "Agentic AI workflow automation platform | Python, LLM integration, agent orchestration | React front-end | Turns complex, manual processes into automated, self-directing pipelines | 2026–Present"
        },
        {
            title: "Area Management System",
            live: "https://github.com/irfanbalghari", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "https://github.com/irfanbalghari", // this should be a link to the **repository** of the project, where the code is hosted.
            image: AreaManage,
            description: "Spatial data system with Containers, Layers, and Areas | Angular, .NET 7, MongoDB | Real-time updates using Angular Signals and RxJS"
        },
        {
            title: "Algo Planner",
            live: "https://github.com/irfanbalghari",
            source: "https://github.com/irfanbalghari",
            image: algoplan,
            description: "Optimized dashboard with improved responsiveness | Integrated APIs, enhanced data-loading efficiency | 2024–2025"
        },
        {
            title: "Order Management System (OMS)",
            live: "https://github.com/irfanbalghari",
            source: "https://github.com/irfanbalghari",
            image: OrderManagement,
            description: "Microservice-based .NET 7 APIs | High-performance architecture | 2023–2024"
        },
        {
            title: "Flex Leasing Platform",
            live: "https://github.com/irfanbalghari",
            source: "https://github.com/irfanbalghari",
            image: flexleasing,
            description: "Complete car leasing workflows and contract management | ASP.NET Core APIs | 2021–2023"
        },
             {
            title: "Starc Education Platform",
            live: "https://github.com/irfanbalghari",
            source: "https://github.com/irfanbalghari",
            image: starc,
            description: "Contributed as a Front-End Developer to the Starc Education Platform, an interactive online learning system enabling seamless collaboration between students and teachers. The platform supported user registration, live class management, assignment handling, group creation, and overall academic workflow."
        },
              {
            title: "Mount Healing",
            live: "https://mounthealing.com",
            source: "https://github.com/irfanbalghari",
            image: mounthealing,
            description: "I designed and developed a modern, user-friendly e-commerce website inspired by the natural richness of Gilgit-Baltistan, focused on promoting organic wellness products and traditional healing solutions."
        }
    ]
};